import React from 'react';
import './TagSection.css'
import { createTagDictionary } from '../models/tagDictionary';
import Chip from '@material-ui/core/Chip';
import RecipeReviewCard from './RecipeReviewCard';

export const TagSection = ({ tags, onAdd }) => {
    const editorTags = createTagDictionary();
    return (
        <div className="tag-section">
            {editorTags.map((t, i) => {
                return (
                    <RecipeReviewCard key={i} tooltipComponent={t.tooltipComponent} groupName={t.groupName} description={t.description} icon={t.icon}>
                        <div className="tag-container" >
                            {t.tags.map((ti, i2) => {
                                return (
                                    <Chip key={i2}
                                        label={ti.labelName}
                                        clickable
                                        className="tag-chip"
                                        onClick={() => onAdd(ti.editFacade)}
                                    />
                                )
                            })}
                        </div>
                    </RecipeReviewCard>
                )
            })}
        </div>
    )
}